import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { MupLayout, StateBadge } from "@/pages/mup/MupLayout";
import { ManualeButton } from "@/components/ManualeButton";
import { Button } from "@/components/ui/button";
import { FilePlus2, FileText, Send, CheckCircle2, XCircle, Clock, Layers, ShieldCheck, ShieldAlert } from "lucide-react";

const CARDS = [
  { key: "bozza", label: "Bozze", icon: FileText, color: "#64748b" },
  { key: "pronto_invio", label: "Pronte per invio", icon: Layers, color: "#1B2380" },
  { key: "inviato", label: "Inviate", icon: Send, color: "#F59E0B" },
  { key: "firmato", label: "Firmate", icon: CheckCircle2, color: "#10B981" },
  { key: "annullato", label: "Annullate", icon: XCircle, color: "#EF4444" },
  { key: "generati_mese", label: "Generati nel mese", icon: Clock, color: "#8B5CF6" },
  { key: "appendici_firmate", label: "Appendici firmate", icon: ShieldCheck, color: "#059669" },
  { key: "appendici_attesa", label: "Appendici da firmare", icon: ShieldAlert, color: "#D97706" },
];

export default function MupDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/mup/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/mup/pratiche").then(({ data }) => setRecent(data.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <MupLayout
      subtitle="Panoramica"
      title="Dashboard MUP"
      actions={
        <div className="flex flex-wrap gap-2">
          <ManualeButton route="/manuale/mup" />
          <Button data-testid="mup-new-pratica-btn" onClick={() => navigate("/mup/nuova")} className="brand-gradient text-white border-0">
            <FilePlus2 className="h-4 w-4 mr-2" /> Nuova pratica
          </Button>
        </div>
      }
    >
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} data-testid={`mup-stat-${c.key}`} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex items-center justify-between mb-3">
                <div className="h-9 w-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${c.color}1A`, color: c.color }}>
                  <Icon className="h-4 w-4" />
                </div>
              </div>
              <div className="text-2xl font-heading font-semibold text-slate-900">{stats ? stats[c.key] ?? 0 : "—"}</div>
              <div className="text-xs text-slate-500 mt-0.5">{c.label}</div>
            </div>
          );
        })}
      </div>

      <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <h3 className="font-heading text-lg text-slate-900">Pratiche recenti</h3>
          <Button variant="ghost" onClick={() => navigate("/mup/pratiche")} className="text-brand-blue">Vedi tutte</Button>
        </div>
        {recent.length === 0 ? (
          <div className="p-10 text-center text-slate-400 text-sm">Nessuna pratica ancora. Crea la prima con "Nuova pratica".</div>
        ) : (
          <div className="divide-y divide-slate-100">
            {recent.map((p) => (
              <button
                key={p.pratica_id}
                data-testid={`mup-recent-${p.pratica_id}`}
                onClick={() => navigate(`/mup/pratiche/${p.pratica_id}`)}
                className="w-full flex items-center justify-between px-4 py-3 hover:bg-slate-50 transition-colors text-left"
              >
                <div>
                  <div className="text-sm font-medium text-slate-900">{p.client_data?.name || "Senza cliente"}</div>
                  <div className="text-xs text-slate-500">{p.code} · {p.client_data?.fiscal_code || p.client_data?.vat || ""}</div>
                </div>
                <StateBadge state={p.state} />
              </button>
            ))}
          </div>
        )}
      </div>
    </MupLayout>
  );
}
